import { render, staticRenderFns } from "./AutoCreateFormTable.vue?vue&type=template&id=f15c80aa&"
import script from "./AutoCreateFormTable.vue?vue&type=script&lang=ts&"
export * from "./AutoCreateFormTable.vue?vue&type=script&lang=ts&"
import style0 from "./AutoCreateFormTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports